module.exports = __webpack_public_path__ + "static/media/angle-right-grey.614b5b48.svg";